import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAWqMV3bmpjCaLzExxmvHGZ-aHr8_mdx3M",
  authDomain: "explorebacoor.firebaseapp.com",
  databaseURL: "https://explorebacoor-default-rtdb.firebaseio.com",
  projectId: "explorebacoor",
  storageBucket: "explorebacoor.appspot.com",
  messagingSenderId: "542364642825",
  appId: "1:542364642825:web:47fccfeb599d4d229a92d8",
  measurementId: "G-Y8PWL3NG3X",
};


const app = initializeApp(firebaseConfig);


const auth = getAuth(app);  
const db = getFirestore(app);  
const storage = getStorage(app);  
const analytics = getAnalytics(app);

export { auth, db, storage };  
export default app; 
